import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layouts
import AuthLayout from "../layouts/AuthLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import EmptyLayout from "../layouts/EmptyLayout";

//Components
import dashboardLayoutRoutes from "./router components/dashboardLayoutRoutes";
import authLayoutRoutes from "./router components/authLayoutRoutes";
import emptyLayoutRoutes from "./router components/emptyLayoutRoutes";
import BlankLayout from "../layouts/Blank";
import blankLayoutRoutes from "./router components/blank";
import pages from "../constants/pages";
import RoleBaseNavigation from "./RoleBaseNavigation";
import { useSelector } from "react-redux";

export default function Router() {
  const { dashboardState } = useSelector((state) => state.memberDetails);

  const allowedPaths = [
    pages.signIn.route,
    pages.welcomePage.route,
    pages.signUp.route,
    pages.resetEmailPasswordPage.route,
    pages.verifyAccount.route + ":code",
    pages.forgotPasswordPage.route + ":code",
    pages.permissionDenied.route,
    pages.superadminLandingPage.route,
  ];

  const allRoutes = useRef([
    {
      ID: "dashboardLayoutRoutes",
      path: "/",
      layout: DashboardLayout,
      children: allChildrenRoutes(dashboardLayoutRoutes),
    },

    {
      ID: "authLayoutRoutes",
      path: "/",
      layout: AuthLayout,
      children: allChildrenRoutes(authLayoutRoutes),
    },

    {
      ID: "emptyLayoutRoutes",
      path: "/",
      layout: EmptyLayout,
      children: allChildrenRoutes(emptyLayoutRoutes),
    },

    {
      ID: "blankLayoutRoutes",
      path: "/",
      layout: BlankLayout,
      children: allChildrenRoutes(blankLayoutRoutes),
    },
  ]);

  return (
    <Routes>
      {allRoutes.current.map(
        ({ ID: layoutID, path, layout: Layout, children }) =>
          layoutID && (
            <Route key={layoutID} path={path} element={<Layout />}>
              {children.map(
                ({
                  ID: pageID,
                  index,
                  path,
                  element: Element,
                  disableAuth,
                  role = [],
                }) =>
                  pageID && allowedPaths.includes(path) ? (
                    <Route
                      key={pageID}
                      index={!!index}
                      path={path}
                      element={
                        <Element pageID={pageID} disableAuth={!!disableAuth} />
                      }
                    />
                  ) : (
                    <Route
                      element={
                        <RoleBaseNavigation
                          role={dashboardState}
                          roles={role}
                        />
                      }
                    >
                      <Route
                        key={pageID}
                        index={!!index}
                        path={path}
                        element={
                          <Element
                            pageID={pageID}
                            disableAuth={!!disableAuth}
                          />
                        }
                      />
                    </Route>
                  )
              )}
            </Route>
          )
      )}
    </Routes>
  );
}

function allChildrenRoutes(parentObject) {
  const childrenArray = [];

  for (var key in parentObject) {
    childrenArray.push(parentObject[key]);
  }

  return childrenArray;
}
